<template>
    <b-row>
        <b-col lg="12" class="px-0 mb-3">
            <h4 class="text-muted">รายละเอียดรับงาน</h4>
        </b-col>
        <b-col lg="12">
            <b-form-group 
                label="วันเวลารับงาน"
            >
                <b-form-input
                    type="datetime-local"
                    disabled
                    v-model="form.driverTimeStart"
                />
            </b-form-group>
        </b-col>
    </b-row>
</template>

<script>
export default {
    props:{
        form: {
            type: Object
        },
    }
}
</script>
